import styled from '@emotion/styled';
import { ButtonLegacy } from '~/shared/components/_Button';

export const StyledLoadPreviousPageButton = styled(ButtonLegacy)<{
    isLoading?: boolean;
    isDisabled?: boolean;
}>(({ isLoading, isDisabled }) => ({
    position: 'relative',
    color: isLoading ? 'transparent' : undefined,
    ...(isDisabled && {
        pointerEvents: 'none',
        opacity: 0.5,
    }),
}));
